<script>
	import { NOTES_PER_CHAPTER, CHAPTERS, NOTES } from '../stores.js';
	import Eclipse from '../Helper/Eclipse.svelte';
	import { secondsToMin, titleClickToStart } from '../utils.js'
	import { onMount } from 'svelte';
  import padStart from 'lodash/padStart';

  let height = 0;
  let wrapper;

  let numberOfNotes = 0;
  NOTES.subscribe(v => {
    numberOfNotes = v.length;
  });

  let notePerChapter = [];
  NOTES_PER_CHAPTER.subscribe(v => {
    notePerChapter = v;
  });

  let chapters = [];
  CHAPTERS.subscribe(v => {
    chapters = v;
  });

  // The height of the single note is the total height of the wrapper minus the number of chapter (since each chapter has a one pixel border at the top) devided by the number of notes
  $: heightOfNote = (height - chapters.length) / numberOfNotes;

  onMount (async () => {
    resize()
  })

  function resize () {
    height = wrapper.getBoundingClientRect().height
  }

  $: style = `height: ${heightOfNote}px;`
  $: eclipseStyle = `font-size: ${heightOfNote - 6}px;`

  function goToSecond (v) { window.goToSecond(v); }
</script>

<svelte:window on:resize={resize} />

<div class="footnotes">
	<div class="chapters" bind:this={wrapper}>
		{#each chapters as { title, number, start: startChapter }}
			<div class={`chapter chapter-${number}`}>
				{#if notePerChapter[number]}
				<div class="notes">
					{#each notePerChapter[number] as { start: startNote, index, preview }}
					<div class="note clickable" style={style} on:click={() => goToSecond(startNote)} title={titleClickToStart(startNote)}>
						<Eclipse i={index} style={eclipseStyle} />
						<span class="note-preview"><time class="note-time">{ secondsToMin(startNote) }</time><span class="note-preview-text">{ @html preview }</span></span>
					</div>
					{/each}
				</div>
				{/if}
				<div class="chapter-title clickable" on:click={() => goToSecond(startChapter)} style={`padding-top: ${heightOfNote}px;`}>
					<span>{ padStart(number, 2, '0') }</span><span>{ title }</span>
				</div>
			</div>
		{/each}
	</div>
</div>